"use client";
import { ReactLenis, useLenis } from "lenis/react";
import { useLenisContext } from "@/context/LenisContext";
import { ReactNode, useEffect, useState } from "react";
import { Orientation } from "lenis";
import { usePathname } from "next/navigation";

const ScrollToTop = () => {
    const lenis = useLenis();
    const pathname = usePathname();

    useEffect(() => {
        // Only run in browser environment
        if (typeof window === 'undefined') return;

        // Scroll to top when pathname changes
        if (lenis) {
            lenis.scrollTo(0, { immediate: true });
        }
    }, [pathname, lenis]);

    return null;
};

const SmoothScroll = ({ children }: {children: ReactNode}) => {
    const [isMounted, setIsMounted] = useState(false);
    const context = useLenisContext();

    useEffect(() => {
        setIsMounted(true);
    }, []);

    // Only render ReactLenis on the client
    if (!isMounted || !context) {
        return <>{children}</>;
    }

    const { lenisMultiplierValue } = context;
    const lenisOptions = {
        duration: 1.75,
        easing: (x: number) => (x === 1 ? 1 : 1 - Math.pow(2, -10 * x)),
        orientation: "vertical" as Orientation,
        gestureOrientation: "vertical" as Orientation,
        smoothWheel: true,
        wheelMultiplier: lenisMultiplierValue ? 0 : 0.95,
        touchMultiplier: lenisMultiplierValue ? 0 : 0.95,
        infinite: false,
    };
    return (
        <ReactLenis root options={lenisOptions}>
            <ScrollToTop />
            {children}
        </ReactLenis>
    );
};

export default SmoothScroll;